<template>
  <v-toolbar dense flat fixed class="minitoolbar" ref="container">

    <v-tabs class="pl-1" style="position: relative; max-width: 60px;" :hide-slider="true">
      <v-tab v-show="!listMode" class="px-3 rounded-tab" :class="ShowJobs ? 'flowout' : ''" style="min-width: unset;"
        @click="ShowJobs = !ShowJobs">
        <v-icon size="20" :color="ShowJobs ? 'tertiary' : 'rgba(0, 0, 0, 0.54)'">mdi-briefcase-eye</v-icon>
      </v-tab>
    </v-tabs>

    <v-spacer />

    <v-tooltip right>
      <template v-slot:activator="{ on, attrs }">
        <v-btn v-bind="attrs" v-on="on" icon class="mr-1" @click="openTrigger++">
          <v-icon>mdi-application-cog</v-icon>
        </v-btn>
      </template>
      <span>{{ $t('servicesystem.common_objects.calendar.settings') }}</span>
    </v-tooltip>
    <QButtonGroup v-model="Mode" :list="modeList" :noempty="true" :edit="true" dense :color="'primary'" class="mr-3">
    </QButtonGroup>
    <QButtonGroup v-model="plannerScope" :list="scopeList" :noempty="true" :edit="true" dense :color="'primary'"
      class="mr-3">
    </QButtonGroup>
    <BryntumDateField :value="currentDate" ref="dateField" :weekStartDay="1" :format="format" :minWidth="180"
      :editable="false" :step="stepSize" :onChange="e => currentDate = e.value">
    </BryntumDateField>

    <v-spacer />

    <v-tabs class="pl-1" style="position: relative; max-width: 50px;" :hide-slider="true">
      <v-tab class="px-3 rounded-tab" :class="ShowMap ? 'flowout' : ''" style="min-width: unset;"
        @click="ShowMap = !ShowMap">
        <v-icon size="20" :color="ShowMap ? 'tertiary' : 'rgba(0, 0, 0, 0.54)'">mdi-map</v-icon>
      </v-tab>
    </v-tabs>
    <!--
    <v-btn color="quaternary" small dark @click="$emit('newEvent', { IsAbsence: false, Type: 1, })">
      <v-icon size="18">mdi-plus</v-icon>
      New appointemnt
    </v-btn>

    <v-btn color="primary" small dark class="mx-3" @click="$emit('newEvent', { IsAbsence: true, Type2: 3, })">
      <v-icon size="18">mdi-plus</v-icon>
      New absence
    </v-btn>
    -->


    <slotted-dialog :externaltrigger="openTrigger" :title="$t('servicesystem.common_objects.calendar.settings')">
      <template v-slot:content>
        <v-container>
          <v-row no-gutters>
            <v-col>
              <h5 v-text="$t('servicesystem.common_objects.job.job_list')" />
              {{ $t("servicesystem.common_objects.job.show_jobs_as") }}
              <QButtonGroup v-model="JobListItemMode" :list="listItemModes" :noempty="true" :edit="true" dense
                class="ma-2">
              </QButtonGroup>
            </v-col>
          </v-row>
          <v-divider />
          <v-row no-gutters>
            <v-col>
              <h5 v-text="$t('servicesystem.common_objects.user.users')" class="mt-3" />
              <QAutoComplete v-model="UserGroupBy" :label="$t('servicesystem.common_objects.commonterms.group_by')" :list="groupAblePropperties"
                :textkey="'text'" :valuekey="'value'" clearable :externaledit="true" :placeholder="$t('servicesystem.common_objects.commonterms.ungrouped')"
                class="my-4">
                <template v-slot:item="{ item }">
                  <v-list-item-content :class="item.Id == 0 ? 'warning--text' : ''">
                    {{ item.text }}
                  </v-list-item-content>
                </template>
              </QAutoComplete>
              <DepartmentSelect v-model="PlannerDepartmentList" :label="$t('servicesystem.common_objects.department.only_users_from_department')"
                :placeholder="$t('servicesystem.common_objects.commonterms.all_departments')" clearable multiple hideIcon externaledit>
              </DepartmentSelect>
              <QAutoComplete v-model="HiddenUserList" :label="$t('servicesystem.common_objects.user.hidden_users')" :list="bookableUsers" :textkey="'name'"
                :valuekey="'id'" clearable multiple :externaledit="true" :placeholder="$t('servicesystem.common_objects.user.no_users_hidden')" class="my-4">
              </QAutoComplete>
            </v-col>
          </v-row>
          <v-divider />
          <v-row no-gutters>
            <v-col class="pa-3 pl-0">
              <h5 v-text="$t('servicesystem.common_objects.commonterms.schedule')" />
              <v-checkbox v-model="limitToWorkHours" hide-details style="min-width: 150px;" class="mt-0"
                :label="$t('servicesystem.common_objects.commonterms.limit_to_workhours', { skey: WorkhourStart, ekey: WorkhourEnd })">
              </v-checkbox>
            </v-col>
            <v-divider vertical />
            <v-col class="pa-3 pr-0">
              <h5 v-text="$t('servicesystem.common_objects.commonterms.list')" />
              <v-checkbox v-model="showAsJobs" :label="$t('servicesystem.common_objects.planner.show_job_appointments_as_jobs')" hide-details dense class="mt-0">
              </v-checkbox>
              <v-checkbox v-model="hideCompletedJobs" :label="$t('servicesystem.common_objects.planner.hide_appointments_where_the_job_is_completed')"
                hide-details dense>
              </v-checkbox>
              <!--  
              <v-checkbox v-model="hideAbsence" :label="'Filter away absences'" hide-details dense>
              </v-checkbox>
              -->
            </v-col>
          </v-row>
        </v-container>
      </template>
    </slotted-dialog>

  </v-toolbar>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import SlottedDialog from "@/views/layouts/SlottedDialog.vue";
import DepartmentSelect from "@/components/Inputs/EntityDropdowns/DepartmentSelect2.vue";
import { BryntumDateField } from "@bryntum/schedulerpro-vue";

export default {
  name: "PlanningToolbar",
  props: {
    jobListWidth: Number,
    showMaps: {
      type: Boolean,
      default: false,
    }
  },
  model: {
    prop: "showMaps",
    event: "change",
  },
  components: {
    SlottedDialog,
    BryntumDateField,
    DepartmentSelect,
  },
  mixins: [clientAPI],

  data() {
    return {
      weekday: [1, 2, 3, 4, 5],
      weekdays: [
        { text: "Mon - Fri", value: [1, 2, 3, 4, 5] },
        { text: "Mon - Sun", value: [1, 2, 3, 4, 5, 6, 0] },
        { text: "Sun - Sat", value: [0, 1, 2, 3, 4, 5, 6] },
      ],

      scopeList: [
        { Id: 1, value: "QDay", text: this.$t('servicesystem.common_objects.commonterms.day') },
        { Id: 2, value: "QWeek", text: this.$t('servicesystem.common_objects.commonterms.week') },
        { Id: 3, value: "QMonth", text: this.$t('servicesystem.common_objects.commonterms.month') },
      ],

      modeList: [
        { Id: 1, value: "Scheduler", text: this.$t('servicesystem.common_objects.commonterms.schedule') },
        { Id: 2, value: "List", text: this.$t('servicesystem.common_objects.commonterms.list') },
      ],

      groupAblePropperties: [
        { Id: 0, value: null, text: this.$t('servicesystem.common_objects.commonterms.ungrouped') },
        { Id: 1, value: "type", text: this.$t('servicesystem.common_objects.user.type') },
        { Id: 2, value: "departmentId", text: this.$t('servicesystem.common_objects.department.department') },
      ],

      listItemModes: [
        { Id: 1, value: null, text: this.$t('servicesystem.common_objects.commonterms.new_list_items') },
        { Id: 2, value: "card", text: this.$t('servicesystem.common_objects.commonterms.old cards') },
      ],

      bookableUsers: [],
      bookableUsersLoading: false,

      openTrigger: 0,
    };
  },

  mounted() {
    this.offsetX = this.$refs.container.$el.getBoundingClientRect().x;
    this.getBookable();
  },

  methods: {
    async getBookable() {
      this.bookableUsersLoading = true;
      await this.getResourceList()
        .then((response) => {
          this.bookableUsers = response;
        })
        .catch((e) => { console.error(e) })
        .finally(() => {
          this.bookableUsersLoading = false;
        });
    },
  },

  computed: {
    ShowJobs: {
      get() {
        return this.$store.getters["prefrences/Prefrence"]("PlannerJobListShow");
      },
      set(update) {
        this.$store.dispatch("prefrences/set_prefrence", { key: "PlannerJobListShow", value: update });
      },
    },

    ShowMap: {
      get() {
        return this.$store.getters["prefrences/Prefrence"]("PlannerMapShow");
      },
      set(update) {
        this.$store.dispatch("prefrences/set_prefrence", { key: "PlannerMapShow", value: update });
      },
    },

    JobListItemMode: {
      get() {
        return this.$store.getters["prefrences/Prefrence"]("PlannerJobListItemMode");
      },
      set(update) {
        this.$store.dispatch("prefrences/set_prefrence", { key: "PlannerJobListItemMode", value: update });
      },
    },

    listWidth() {
      var percent = this.jobListWidth;
      var width = ((window.innerWidth - this.offsetX) * percent) / 100;

      //console.log('width', width, percent);
      return width + 'px';
    },

    Mode: {
      get() {
        return this.$store.getters["prefrences/Prefrence"]("PlannerMode");
      },
      set(update) {
        this.$store.dispatch("prefrences/set_prefrence", { key: "PlannerMode", value: update });
      },
    },
    listMode() {
      return this.Mode == 'List';
    },

    plannerScope: {
      get() {
        return this.$store.getters["prefrences/Prefrence"]("PlannerScope");
      },
      set(update) {
        this.$store.dispatch("prefrences/set_prefrence", { key: "PlannerScope", value: update });
      },
    },
    format() {
      var keyMapObj = {
        'QMonth': 'MMMM Y',
        'QWeek': 'Wp Y',
      };
      var forma = keyMapObj[this.plannerScope] ?? 'ddd D. MMM Y';
      return forma;
    },
    stepSize() {
      var keyMapObj = {
        'QMonth': "1 month",
        'QWeek': "1 week"
      };
      var step = keyMapObj[this.plannerScope] ?? "1d";
      return step;
    },

    limitToWorkHours: {
      get() {
        return this.$store.getters["prefrences/Prefrence"]("LimitToWorkHours");
      },
      set(update) {
        this.$store.dispatch("prefrences/set_prefrence", { key: "LimitToWorkHours", value: update });
      },
    },

    WorkhourStart() {
      var stored = this.$store.getters["plannerstore/WorkhourStart"];
      var rounded = (Math.round(stored * 4) / 4).toFixed(2);
      return rounded;
    },
    WorkhourEnd() {
      var stored = this.$store.getters["plannerstore/WorkhourEnd"];
      var rounded = (Math.round(stored * 4) / 4).toFixed(2);
      return rounded;
    },

    currentDate: {
      get() {
        return this.$store.getters["plannerstore/CalendarDateStart"];
      },
      set(update) {
        this.$store.dispatch("plannerstore/SetCalendarStartDate", update);
      },
    },

    UserGroupBy: {
      get() {
        return this.$store.getters["prefrences/Prefrence"]("PlannerUserGroupBy");
      },
      set(update) {
        if (!update) { update = false } //null or undefined will be reset to preference deafault value on refresh, false won't.
        this.$store.dispatch("prefrences/set_prefrence", { key: "PlannerUserGroupBy", value: update });
      },
    },

    HiddenUserList: {
      get() {
        return this.$store.getters["prefrences/Prefrence"]("PlannerHiddenUserList");
      },
      set(update) {
        this.$store.dispatch("prefrences/set_prefrence", { key: "PlannerHiddenUserList", value: update });
      },
    },

    PlannerDepartmentList: {
      get() {
        return this.$store.getters["prefrences/Prefrence"]("PlannerDepartmentList");
      },
      set(update) {
        this.$store.dispatch("prefrences/set_prefrence", { key: "PlannerDepartmentList", value: update });
      },
    },

    showAsJobs: {
      get() {
        return this.$store.getters["prefrences/Prefrence"]("PlannerListShowAsJobs");
      },
      set(update) {
        this.$store.dispatch("prefrences/set_prefrence", { key: "PlannerListShowAsJobs", value: update });
      },
    },
    hideCompletedJobs: {
      get() {
        return this.$store.getters["prefrences/Prefrence"]("PlannerListHideCompletedJobs");
      },
      set(update) {
        this.$store.dispatch("prefrences/set_prefrence", { key: "PlannerListHideCompletedJobs", value: update });
      },
    },
    hideAbsence: {
      get() {
        return this.$store.getters["prefrences/Prefrence"]("PlannerListHideAbsence");
      },
      set(update) {
        this.$store.dispatch("prefrences/set_prefrence", { key: "PlannerListHideAbsence", value: update });
      },
    },
  },

  watch: {
    toggleMaps: function () {
      this.$emit('update:showMaps', this.toggleMaps == 0)
    }
  },
};
</script>


<style lang='scss' scoped>
::v-deep .v-input--checkbox .v-label {
  font-size: 13px !important;
  margin-left: 4px;
}

</style>